import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import AgentSignupRequest from "../Agent/AgentSignupRequest";
import { useAgentAuth } from "../Agent/AgentAuthContext";

const AgentForm = () => {
  const navigate = useNavigate();
       const { http, token } = AuthUser();

  const { setIsAuthenticated, setAgentData } = useAgentAuth();

  const [showLoginForm, setShowLoginForm] = useState(false); // default to signup request
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const toggleForms = () => {
    setShowLoginForm(!showLoginForm);
    setError(null);
  };

  const submitLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await http.post("/agent-login", { email, password }, {
        headers: { "Content-Type": "application/json" },
      });

      localStorage.setItem("agent_token", response.data.token);
      localStorage.setItem("agent", JSON.stringify(response.data.agent));
      localStorage.setItem("agentData", JSON.stringify(response.data.agentData));
      setIsAuthenticated(true);
      setAgentData(response.data.agent);
      navigate("/");
    } catch (err) {
      const errorData = err.response?.data;
      setError(errorData?.errors || errorData?.message || "Login failed!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-g">
      <div className="containerr h-100 d-flex justify-content-center align-items-center">
        <div className="containerr d-flex justify-content-center align-items-center">

          {/* Left Logo Side */}
          <div className="col-lg-6 h100 d-flex flex-column justify-content-center align-items-center bg-blue">
            <div className="rounded text-black text-center">
              <div className="agent-log-img">
                <Link to="/">
                  <img className='log-logo' src="assets/img/logo/footer-logo10a.png" alt="logo" />
                </Link>
                <img src="assets/img/images/agent-login.png" alt="illustration" />
              </div>
              <div className="txtt agent-txt">
                <h3>Welcome, Partners! </h3>
                <h4 className="agent-login-txt">

                  Log in to manage your legal franchise services, support clients locally, and grow with us.</h4>
              </div>
            </div>
          </div>

          {/* Right Form Side */}
          <div className="col-lg-6 h100 d-flex flex-column justify-content-center align-items-center bg-g">
            <div className="card form-sec m-4 rounded-3 color text-black">
              <div className="card-body p-4 mx-4">



                {/* Forms */}
                {!showLoginForm ? (
                  <form onSubmit={submitLogin}>
                    <h4 className="text-center mb-4">Agent Login</h4>

                    <div className="form-outline mb-3">
                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        id="email"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>

                    <div className="form-outline mb-3">
                      <label htmlFor="password">Password</label>
                      <input
                        type="password"
                        id="password"
                        className="form-control"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>

                    {error && (
                      <div className="text-danger text-center mb-2"
                        style={{
                          maxWidth: '315px',
                          margin: '0 auto',
                          wordWrap: 'break-word',
                          whiteSpace: 'pre-wrap',
                        }}>
                        {typeof error === "string"
                          ? error
                          : Object.keys(error).map((key) => (
                            <p key={key}>{error[key][0]}</p>
                          ))}
                      </div>
                    )}

                    <button type="submit" className="btn btn-primary btn-block w-100 mb-3" disabled={loading}>
                      {loading ? "Logging in..." : "Login"}
                    </button>
                  </form>
                ) : (
                  <>
                    <h4 className="text-center mb-4">Agent Signup Request</h4>
                    <AgentSignupRequest />
                  </>

                )}

                <div className="text-center mt-3 form-end d-flex justify-content-end align-items-center gap-2">
                  {/* Toggle Button */}
                  <div className=" text-center ">
                    <button
                      className="btn btn-outline-primary"
                      onClick={toggleForms}
                    >
                      {showLoginForm ? "Go to Login" : "Make Signup Request"}
                    </button>
                  </div>
                  <Link to="/" className="btn btn-outline-primary">Back to Home</Link>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AgentForm;
